import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import RtReconciliationSearchMatchedRequest from "../RtReconciliationSearchMatchedRequest";
import ModelProxyClass from "./ModelProxyClass";


/**
 * @class RtReconciliationSearchMatchedRequestBase
 * @extends ModelBaseClass
 * @property {number} tenantId (int64)
 * @property {Date} dateRangeStart (date only)
 * @property {Date} dateRangeEnd (date only)
 */
class RtReconciliationSearchMatchedRequestBase extends ModelBaseClass {
	/**
	 * @type {number} tenantId (int64)
	 */
	tenantId;
	/**
	 * @type {Date} dateRangeStart (date only)
	 */
	dateRangeStart;
	/**
	 * @type {Date} dateRangeEnd (date only)
	 */
	dateRangeEnd;

	/**
	 * Instantiates a new instance of RtReconciliationSearchMatchedRequest based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {RtReconciliationSearchMatchedRequest}
	 */
	static create(genericObject) {
		const newRtReconciliationSearchMatchedRequest = new RtReconciliationSearchMatchedRequest();
		newRtReconciliationSearchMatchedRequest.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newRtReconciliationSearchMatchedRequest;
	}

	/**
	 * Instantiates a new array of RtReconciliationSearchMatchedRequest based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[RtReconciliationSearchMatchedRequest]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newRtReconciliationSearchMatchedRequestArray = [];
		genericArray.forEach(genericObject => {
			newRtReconciliationSearchMatchedRequestArray.push(RtReconciliationSearchMatchedRequest.create(genericObject));
		});
		return newRtReconciliationSearchMatchedRequestArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('tenantId', 'integer'),
	ModelBaseClass.createModelProperty('dateRangeStart', 'datetime'),
	ModelBaseClass.createModelProperty('dateRangeEnd', 'datetime'),
];

export default RtReconciliationSearchMatchedRequestBase;
